module.exports = __webpack_public_path__ + "static/img/076_TO8_1708_og.fc028e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/076_TO8_1708_og.jpg
// module id = 94ly
// module chunks = 0